import { createContext, useContext } from "react";

interface StepContextValue {
  isActive: boolean;
  isPast: boolean;
  stepIndex: number;
  isLastStep: boolean;
  totalSteps: number;
  fullScreen?: boolean;
}

const StepContext = createContext<StepContextValue | undefined>(undefined);

export const StepContextProvider = StepContext.Provider;

/**
 * Hook to access step context information
 * Provides information about whether the current step is active or past
 */
export const useStepContext = (): StepContextValue => {
  const context = useContext(StepContext);
  if (!context) {
    throw new Error("useStepContext must be used within StepContextProvider");
  }
  return context;
};
